import { useEffect, useRef, useState } from "react";
import { highlightLine, type Token } from "./highlight";

const tokenClass: Record<Token["kind"], string> = {
  comment: "italic text-mut",
  string: "text-warn",
  keyword: "text-acc",
  number: "text-info",
  func: "font-semibold text-ink",
  plain: "",
};

export const COPY_RESET_MS = 1600;

/** Кнопка «копировать» → «✓ скопировано» на 1.6 с (A0). */
export function CopyButton({ text }: { text: string }) {
  const [done, setDone] = useState(false);
  const timer = useRef<number | undefined>(undefined);
  useEffect(() => () => window.clearTimeout(timer.current), []);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      /* без clipboard API кнопка всё равно показывает состояние */
    }
    setDone(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setDone(false), COPY_RESET_MS);
  };
  return (
    <button
      type="button"
      onClick={copy}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-[3px] border px-[9px] py-1 font-mono text-[11px] ${
        done ? "border-ok bg-oksoft text-ok" : "border-bd2 bg-transparent text-ink2 hover:border-acc hover:text-acc"
      }`}
    >
      {done ? "✓ скопировано" : "копировать"}
    </button>
  );
}

export function CodeBlock({ code, label = "python", flat = false }: { code: string; label?: string; flat?: boolean }) {
  const lines = code.replace(/\n$/, "").split("\n");
  const gutter = String(lines.length).length * 9 + 18;
  return (
    <div className={flat ? "" : "overflow-hidden rounded-md border border-bd bg-bg2"}>
      {!flat && (
        <div className="flex items-center gap-2.5 border-b border-bd bg-card px-2.5 py-[7px] font-mono text-[11px] text-mut">
          <span>{label}</span>
          <span className="flex-1" />
          <CopyButton text={code} />
        </div>
      )}
      <pre className="m-0 overflow-x-auto py-3 pr-3.5 font-mono text-[12.5px] leading-[1.65] text-ink">
        {lines.map((line, i) => (
          <div key={i} className="grid" style={{ gridTemplateColumns: `${gutter}px minmax(0,1fr)` }}>
            <span aria-hidden className="select-none pr-3 text-right text-mut opacity-70">
              {i + 1}
            </span>
            <code>
              {highlightLine(line).map((t, j) => (
                <span key={j} className={tokenClass[t.kind]}>
                  {t.text}
                </span>
              ))}
              {line === "" ? " " : null}
            </code>
          </div>
        ))}
      </pre>
    </div>
  );
}
